/**
 * @ngdoc service
 * @name app.regionService
 * @description
 * # regionService
 * Service to talk with backend api.
 * Get current region data as well as all regions.
 * @requires app.apiService
 * @requires constants:config
 **/
/*---------------------------------------------------------*\
 * Imports
\*---------------------------------------------------------*/
import angular from 'angular';

/*---------------------------------------------------------*\
 * regionService
\*---------------------------------------------------------*/
/* @ngInject */
function regionService(apiService, config) {
  // APIs
  /**
   * @ngdoc
   * @name app.regionService#getRegions
   * @methodOf app.regionService
   * @example
   * ``` js
   * regionService.getRegions();
   * ```
   * @description
   * Service to talk with backend api.
   * It forms a string url using config relative base url, '/region/info' string.
   * It will call apiService.wrap function with the string formed as a param.
   * @returns {httpPromise} Promise that will resolve into an object with all available regions.
   **/
  this.getRegions = () => {
    return apiService.wrap(config.relBaseUrlAPi + '/region/info',
    {}, 'regions');
  };

  /**
   * @ngdoc
   * @name app.regionService#getCities
   * @methodOf app.regionService
   * @example
   * ``` js
   * regionService.getCities('CT');
   * ```
   * @param {string} region selected region abbreviation, case 'Bronx' => 'BX',
   * 'New Jersey' => 'NJ', max of two characters.
   * @description
   * Service to talk with backend api.
   * It forms a string url using config relative base url, '/region/info' string.
   * It will call apiService.wrap function with the string formed as a param.
   * @returns {httpPromise} Promise that will resolve into a string url, or it
   * Will throw an error if region code is not a string or is the incorrect length.
  **/
  this.getCities = (regionCode) => {
    if (!angular.isString(regionCode) || regionCode.length !== 2) {
      throw new Error('A two-character region code is required');
    }
    return apiService.wrap(`${config.relBaseUrlAPi}/schools/cities/${regionCode}`,
        {}, 'regions');
  };
}

regionService.$inject = [
  'apiService',
  'config'
];

const api = angular
  .module('regionService', ['config', 'apiService'])
  .service('regionService', regionService);

export default api;



/** WEBPACK FOOTER **
 ** ./client/app/services/apis/regions.js
 **/